module.exports = __webpack_public_path__ + "static/media/soundBalanceF.1176e41d.mp3";